<template>
  <button
    @click="toggleExpanded"
    @keydown="handleTabKey"
    aria-haspopup="true"
    :aria-expanded="expanded.toString()"
  >
    <slot />
  </button>
</template>

<script>
import eventBus from '@/js/util/eventBus'

export default {
  data() {
    return {
      expanded: false,
    }
  },
  props: {
    view: {
      type: String,
      default: 'mobile',
    },
  },
  methods: {
    toggleExpanded() {
      this.expanded = !this.expanded
      eventBus.$emit('nav:search', this.expanded)
    },
    handleEsc(event) {
      if (event.keyCode === 27 && this.expanded) {
        this.expanded = false
        eventBus.$emit('nav:search', this.expanded)
        this.$el.focus()
      }
    },
    handleTabKey(event) {
      if (this.expanded && event.key == 'Tab') {
        event.preventDefault()
        if (event.shiftKey) {
          event.stopPropagation()
          eventBus.$emit('nav:search:focus:last')
        } else {
          eventBus.$emit('nav:search:focus:first')
        }
      }
    },
    getFocus() {
      this.$el.focus()
    },
    navOpened(nav) {
      if (nav && this.expanded) {
        this.expanded = false
        eventBus.$emit('nav:search', this.expand)
      }
    },
  },
  mounted() {
    window.addEventListener('keyup', this.handleEsc)
    eventBus.$on('nav:search:focus', this.getFocus)
    eventBus.$on('toggle:menu', this.navOpened)
    eventBus.$on('nav:desktop:opened', this.navOpened)
  },
}
</script>
